import React, { useEffect, useState } from 'react';
import { Button, Form, Input, List, Modal, notification, Select, Space, Spin } from 'antd';
import { Localization, _T } from '../../../../../base-react/src/Localization';
import { FileAddOutlined, SearchOutlined } from '@ant-design/icons';
import { apis, models } from "@vote4dance/judging-sdk";
var Api = apis.Api;
var CustomerSource = models.customers.CustomerSource;
const CustomerBilling = ({ value, onChange, placeholder }) => {
    const [visible, setVisible] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const [canAddNewCustomer, setCanAddNewCustomer] = useState(true);
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState();
    const [billingCustomer, setBillingCustomer] = useState();
    useEffect(() => {
        if (value) {
            try {
                var json = JSON.parse(value);
                if (typeof json === 'object' && json.customer_id) {
                    getCustomer(json.customer_id);
                }
            }
            catch (e) {
                // Old customers, skip
            }
        }
    }, [value]);
    const getCustomer = (id) => {
        setIsSearching(true);
        Api.call(`${CustomerSource.url}`, 'get-customer', {
            customer_id: id
        })
            .then((result) => {
            setIsSearching(false);
            setBillingCustomer(result);
        })
            .catch((err) => {
            setBillingCustomer(undefined);
            notification.error({
                message: _T('customer.error.' + err.message)
            });
            setIsSearching(false);
        });
    };
    const onSearchCustomer = () => {
        setVisible(true);
    };
    const handleCancel = () => {
        setSelectedCustomer(undefined);
        setCustomers([]);
        setIsSearching(false);
        setVisible(false);
        setCanAddNewCustomer(true);
    };
    const handleOk = (result) => {
        const targetCustomer = (result && result.customer_id) || selectedCustomer;
        if (targetCustomer) {
            const customerId = targetCustomer.customer_id;
            let newValue;
            if (value) {
                try {
                    var json = JSON.parse(value);
                    if (typeof json === 'object') {
                        json.customer_id = customerId;
                        newValue = JSON.stringify(json);
                    }
                }
                catch (e) {
                    newValue = JSON.stringify({
                        customer_id: customerId
                    });
                }
            }
            else {
                newValue = JSON.stringify({
                    customer_id: customerId
                });
            }
            setBillingCustomer(targetCustomer);
            onChange(newValue);
        }
        handleCancel();
    };
    const onSearch = (searchText) => {
        if (searchText.length <= 3) {
            return;
        }
        setIsSearching(true);
        Api.call(`${CustomerSource.url}`, 'search-customer', {
            text: searchText
        })
            .then((result) => {
            setIsSearching(false);
            setCustomers(result);
        })
            .catch((err) => {
            setCustomers([]);
            notification.error({
                message: _T('customer.error.' + err.message)
            });
            setIsSearching(false);
        });
    };
    const onChangeSearch = (event) => {
        if (event.target.value.length <= 3) {
            setCustomers([]);
            setCanAddNewCustomer(true);
        }
    };
    const onSelectCustomer = (item) => {
        setSelectedCustomer(selectedCustomer == item ? undefined : item);
    };
    const onAddCustomer = () => {
        const newCustomer = {
            customer_type: 'private',
            customer_locale: Localization.getLanguage(),
            customer_country_code: Localization.getLanguage() == 'sv' ? 'SE' : undefined
        };
        setCustomers(items => [...items, newCustomer]);
        setCanAddNewCustomer(false);
    };
    return (React.createElement(React.Fragment, null,
        !visible && isSearching ? React.createElement(Spin, null) :
            React.createElement(Space, { style: { width: '100%' }, orientation: 'vertical' },
                billingCustomer && React.createElement(Input, { value: billingCustomer.customer_name + ' (' + billingCustomer.customer_email + ')', disabled: true }),
                React.createElement(Button, { icon: React.createElement(SearchOutlined, null), onClick: onSearchCustomer }, _T('common.select', { name: _T('customer.label').toLowerCase() }))),
        React.createElement(Modal, { title: _T('common.select', { name: _T('customer.label').toLowerCase() }), open: visible, okButtonProps: { disabled: !selectedCustomer }, okText: _T('common.ok'), cancelText: _T('common.cancel.title'), onCancel: handleCancel, onOk: handleOk },
            React.createElement(Space, { orientation: 'vertical', style: { width: '100%' } },
                React.createElement(Input.Search, { placeholder: _T('common.search', { name: _T('customer.label').toLowerCase() }), onSearch: onSearch, onChange: onChangeSearch, loading: isSearching, allowClear: true, autoFocus: true }),
                React.createElement(List, { bordered: true, dataSource: customers, loading: isSearching, footer: React.createElement(Button, { disabled: !canAddNewCustomer, block: true, icon: React.createElement(FileAddOutlined, null), onClick: onAddCustomer }, _T('common.add', { name: _T('customer.label').toLowerCase() })), renderItem: (item) => (React.createElement(List.Item, { actions: item.customer_id ? [
                            React.createElement(Button, { type: selectedCustomer && selectedCustomer == item ? "primary" : "dashed", onClick: () => onSelectCustomer(item) }, _T('common.' + selectedCustomer && selectedCustomer == item ? 'selected' : 'select'))
                        ] : [] }, item.customer_id ? (React.createElement(List.Item.Meta, { title: item.customer_name, description: item.customer_email })) : (React.createElement(CustomerDetailsForm, { customer: item, onCreate: handleOk })))) })))));
};
const CustomerDetailsForm = ({ customer, onCreate }) => {
    const [showCompanyInfo, setShowCompanyInfo] = useState(false);
    const [loading, setLoading] = useState(false);
    const onFinish = (values) => {
        setLoading(true);
        const newCustomer = ({
            ...customer,
            ...values
        });
        Api.create(`${CustomerSource.url}`, newCustomer)
            .then((result) => {
            setLoading(false);
            onCreate(result);
        })
            .catch((err) => {
            setLoading(false);
            notification.error({
                message: _T('customer.error.' + err.message)
            });
        });
    };
    const onValuesChange = (changedValues, allValues) => {
        const changeKeys = Object.keys(changedValues);
        if (changeKeys.includes('customer_type')) {
            setShowCompanyInfo(changedValues['customer_type'] == 'company');
        }
    };
    return (React.createElement(Form, { name: "customer_details_form", labelCol: { span: 6 }, wrapperCol: { span: 18 }, initialValues: customer, onValuesChange: onValuesChange, onFinish: onFinish, autoComplete: "off", style: { width: '100%' }, labelWrap: true },
        React.createElement(Form.Item, { name: "customer_type", label: _T('customer.details.customer_type.label') },
            React.createElement(Select, null,
                React.createElement(Select.Option, { value: "private", key: 0 }, _T('customer.details.customer_type.private')),
                React.createElement(Select.Option, { value: "company", key: 1 }, _T('customer.details.customer_type.company')))),
        React.createElement(Form.Item, { name: "customer_name", rules: [{ required: true, message: _T('common.required') }], label: _T('customer.details.customer_name') },
            React.createElement(Input, null)),
        React.createElement(Form.Item, { name: "customer_email", rules: [
                { required: true, message: _T('common.required') },
                {
                    type: 'email'
                },
            ], label: _T('customer.details.customer_email') },
            React.createElement(Input, { type: "email" })),
        React.createElement(Form.Item, { name: "customer_address_1", label: _T('customer.details.customer_address_1') },
            React.createElement(Input, null)),
        React.createElement(Form.Item, { name: "customer_address_2", label: _T('customer.details.customer_address_2') },
            React.createElement(Input, null)),
        React.createElement(Form.Item, { name: "customer_zip_code", label: _T('customer.details.customer_zip_code') },
            React.createElement(Input, null)),
        React.createElement(Form.Item, { name: "customer_city", label: _T('customer.details.customer_city') },
            React.createElement(Input, null)),
        React.createElement(Form.Item, { name: "customer_organization_number", label: _T('customer.details.customer_organization_number'), hidden: !showCompanyInfo },
            React.createElement(Input, null)),
        React.createElement(Form.Item, { name: "customer_vat_number", label: _T('customer.details.customer_vat_number'), hidden: !showCompanyInfo },
            React.createElement(Input, null)),
        React.createElement(Form.Item, { name: "customer_country_code", rules: [{ required: true, message: _T('common.required') }], label: _T('customer.details.customer_country_code') },
            React.createElement(Select, { allowClear: true, showSearch: true, optionFilterProp: "label", options: Object.keys(Localization.getCountryNames()).map((code, index) => ({
                    value: code,
                    label: Localization.getCountryName(code),
                })) })),
        React.createElement(Form.Item, { wrapperCol: { offset: 8, span: 16 } },
            React.createElement(Button, { type: "primary", htmlType: "submit", loading: loading }, _T('common.save')))));
};
export default CustomerBilling;
